"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constellation_1 = require("@zillow/constellation");
const react_1 = __importStar(require("react"));
const RateCard_1 = __importDefault(require("./RateCard"));
const PersonalizedRateCard_1 = __importDefault(require("./PersonalizedRateCard"));
const CardsContext_1 = __importDefault(require("../../context/CardsContext"));
const RateCardsCarousel = ({ cardsInfo }) => {
    const { tabbed } = (0, react_1.useContext)(CardsContext_1.default);
    function mergeData() {
        var _a, _b;
        const data0 = ((_a = cardsInfo[0]) === null || _a === void 0 ? void 0 : _a.data) || [];
        if (tabbed) {
            const data1 = ((_b = cardsInfo[1]) === null || _b === void 0 ? void 0 : _b.data) || [];
            return [...data0, ...data1];
        }
        else {
            return data0;
        }
    }
    const displayData = mergeData();
    return (react_1.default.createElement(constellation_1.Carousel, { slideWidth: "280", enableSnap: true },
        displayData.map((card) => (react_1.default.createElement(RateCard_1.default, { ...card, key: card.title }))),
        react_1.default.createElement(PersonalizedRateCard_1.default, null)));
};
exports.default = RateCardsCarousel;
